import { forwardRef } from "react";
// Utils
import { ICON_NAMES, ICON_COLOURS } from "constants/Icons";
// Components
import { Icon } from "../Icon";
import { Text } from "../Text";
// Resources
import styles from "./IconLabel.module.scss";

export interface IconLabelProps {
  colour: keyof typeof ICON_COLOURS;
  icon: keyof typeof ICON_NAMES;
  id?: string;
  label: string;
}

export const IconLabel = forwardRef<HTMLSpanElement, IconLabelProps>(
  ({ colour, icon, id, label, ...props }, forwardedRef): JSX.Element => {
    const ariaId = id || `icon_label`;

    return (
      <span {...props} className={styles.icon_label} ref={forwardedRef}>
        <Icon className={styles["icon_label__icon"]} colour={colour} name={icon} size="tiny" ariaLabelledBy={ariaId} />
        <Text id={ariaId} smallest>
          {label}
        </Text>
      </span>
    );
  },
);
IconLabel.displayName = "IconLabel";
